import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AddAgendaComponent} from './add-agenda/add-agenda.component';
import {AddSessionComponent} from './add-session/add-session.component';
import {AddTrackComponent} from './add-track/add-track.component';
import {AgendaService} from 'src/app/services/agenda.service';
import {Agenda} from 'src/app/entities/agenda';
import {ToastrService} from 'ngx-toastr';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {TrackService} from 'src/app/services/track.service';
import {ProposalOrder} from 'src/app/entities/proposalOrder';
import {StorageMap} from '@ngx-pwa/local-storage';
import {Subscription, timer} from 'rxjs';
import {Session} from 'src/app/entities/session';
import {Track} from 'src/app/entities/track';
import {AuthService} from 'src/app/services/auth.service';
import {GenAgendaComponent} from './gen-agenda/gen-agenda.component';
import {TrackNotesComponent} from '../track-notes/track-notes.component';
import {TrackDocumentationComponent} from '../track-documentation/track-documentation.component';
import {SessionService} from "../../services/session.service";
import {AddUrlComponent} from "./add-url/add-url.component";
import {OpenSpaceService} from 'src/app/services/open-space.service';
import {OpenSpace} from 'src/app/entities/openSpace';

@Component({
    selector: 'app-agenda',
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.css'],
})
export class AgendaComponent implements OnInit, OnDestroy, AfterViewInit {

    constructor(private matDialogService: MatDialog,
                private storage: StorageMap,
                private agendaService: AgendaService,
                private trackService: TrackService,
                private toastr: ToastrService,
                private sessionService: SessionService,
                private openSpaceService: OpenSpaceService,
                private authServ: AuthService,
                private cd: ChangeDetectorRef) {
    }

    openSpaceId: number;
    agenda: Agenda;
    sessions: Session[];
    unassignedProposals: ProposalOrder[];
    dataSubscription: Subscription;
    isAdmin = false;
    noPublishAgenda = false;
    filterByVotes = true;
    filterByIntention = false;
    eventDate: OpenSpace;
    startTime: Agenda;


    ngOnInit() {
        this.isAdmin = this.authServ.isAdminAccount();
        this.loadcontent();
    }

    ngAfterViewInit() {
        if (this.agenda !== undefined) {
            this.loadAgenda();
        }
    }

    ngOnDestroy() {
        if (this.isAdmin) {
            this.dataSubscription.unsubscribe();
        }
    }

    getColor(proposalId: number) {
        return proposalId.toString().substring(proposalId.toString().length - 1);
    }

    loadAgenda() {
        this.agenda = undefined;
        if (this.openSpaceId !== undefined) {
            if (this.isAdmin) {
                this.agendaService.getAdminAgenda(this.openSpaceId).subscribe(
                    data => {
                        if (data.Agendas.length > 0) {
                            this.agenda = data.Agendas[0];
                            this.unassignedProposals = data.UnasignedProposals;
                            this.displayReminder(this.agenda.sessions);
                        }
                    });
            } else {
                this.agendaService.getUserAgenda(this.openSpaceId).subscribe(
                    data => {
                        if (data.Agendas.length > 0) {
                            this.agenda = data.Agendas[0];
                            this.unassignedProposals = data.UnasignedProposals;
                            this.noPublishAgenda = false;
                            this.displayReminder(this.agenda.sessions);
                        } else {
                            this.noPublishAgenda = true;
                        }
                    });
            }
        }
    }

    displayReminder(sessionsSet) {
        this.openSpaceService.getOpenSpace(this.openSpaceId).subscribe(
            data => {
                if (data.OpenSpaces.length > 0) {
                    const sessionOpenSpaceDate = new Date(data.OpenSpaces[0].eventDate);
                    const today = new Date();

                    for (let session in sessionsSet) {
                        const sessionStartTime = sessionsSet[session].startTime.split(':');
                        const sessionHours = sessionStartTime[0];
                        const sessionMinutes = sessionStartTime[1];

                        sessionOpenSpaceDate.setHours(sessionHours);
                        sessionOpenSpaceDate.setMinutes(sessionMinutes);

                        const diffMs = (sessionOpenSpaceDate.getTime() - today.getTime());
                        const diffMins = Math.floor((diffMs / 1000) / 60);

                        if (diffMins >= 0 && diffMins <= 15) {
                            sessionsSet[session].displayable = true;
                            sessionsSet[session].secondsRemaining = diffMins * 60;
                        }
                    }
                }
            }
        );
    }

    addAgendaOpen(openSpaceId: number) {
        if (openSpaceId === 0) {
            this.toastr.info('Para generar una agenda, debe seleccionar un OpenSpace');
            return;
        }
        const dialogRef = this.matDialogService.open(AddAgendaComponent, {
            data: {openSpaceId, editMode: false}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                this.loadAgenda();
            }),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }


    addSessionOpen(agendaId: number) {
        const dialogRef = this.matDialogService.open(AddSessionComponent, {
            data: {agendaId, editMode: false}
        });
        dialogRef.afterClosed().subscribe(
            (data => {
                    if (data) {
                        const startTimeValue = dialogRef.componentInstance.startTime.value;
                        if (startTimeValue >= this.agenda.startTime) {
                            if (data.minutesDuration > 0) {
                                this.sessionService.addSession(data).subscribe((data: any) => {
                                    const savedSession = new Session();
                                    savedSession.agendaId = agendaId;
                                    savedSession.id = data.Sessions[0].id;
                                    savedSession.startTime = data.Sessions[0].startTime;
                                    savedSession.minutesDuration = data.Sessions[0].minutesDuration;
                                    savedSession.tracks = new Array<Track>();
                                    this.agenda.sessions.push(savedSession);
                                });
                                this.toastr.success('Sesión creada');
                            } else {
                                this.toastr.error('La duración de la sesión debe ser mayor a 0 minutos');
                            }
                        } else {
                            this.toastr.error('La hora de inicio de la sesión debe ser posterior o igual a la del evento');
                        }
                    }
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    editSession(session: Session) {
        const dialogRef = this.matDialogService.open(AddSessionComponent, {
            data: {agendaId: this.agenda.id, session, editMode: true}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
            }),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    editAgenda(agenda: Agenda) {
        const dialogRef = this.matDialogService.open(AddAgendaComponent, {
            data: {agenda, editMode: true, openSpaceId: this.openSpaceId}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    updateAgenda(agenda: Agenda) {
        this.agendaService.updateAgenda(agenda.id, agenda)
            .subscribe(
                (data) => {
                    if (data?.success) {
                        this.loadAgenda();
                    }
                },
                error => {
                    console.error(error);
                }
            );
    }

    editTrack(track: Track, sessionId: number) {
        const dialogRef = this.matDialogService.open(AddTrackComponent, {
            data: {sessionId, track, editMode: true}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    addTrackOpen(sessionId: number) {
        const dialogRef = this.matDialogService.open(AddTrackComponent, {data: {sessionId}});
        dialogRef.afterClosed().subscribe(
            (data => {
                    if (data !== undefined) {
                        const savedTrack = new Track();
                        savedTrack.sessionId = sessionId;
                        savedTrack.id = data.Tracks[0].id;
                        savedTrack.channel = data.Tracks[0].channel;
                        savedTrack.proposals = new Array<ProposalOrder>();
                        savedTrack.documentation = data.Tracks[0].documentation;
                        savedTrack.talkLink = data.Tracks[0].talkLink;
                        this.agenda.sessions.find(obj => obj.id === sessionId).tracks.push(savedTrack);
                    }
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
        this.onSaveAgenda();
    }

    onSaveAgenda() {
        const proposalList = new Array<ProposalOrder>();
        this.addAssignedProposalsToList(proposalList);
        this.addUnassignedProposalsToList(proposalList);
        if (this.isInvalidListOfProposals(proposalList)) {
            return;
        }
        this.trackService.assignProposalsOrders(proposalList).subscribe(
            (data) => {
                this.toastr.success('Agenda guardada');
                this.loadAgenda();
            },
            (error) => {
                console.error(error);
            }
        );
    }

    showNotesTrack(track: Track) {
        const dialogRef = this.matDialogService.open(TrackNotesComponent, {
            data: {track}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    editUrlDocTrack(track: Track, sessionId: number) {
        const dialogRef = this.matDialogService.open(TrackDocumentationComponent, {
            data: {sessionId, track}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

    editUrlTalk(track: Track, sessionId: number) {
        const dialogRef = this.matDialogService.open(AddUrlComponent, {
            data: {sessionId, track}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }


    addAssignedProposalsToList(proposalList: Array<ProposalOrder>) {
        for (const session of this.agenda.sessions) {
            for (const track of session.tracks) {
                for (let z = 0; z < track.proposals.length; z++) {
                    const prop = track.proposals[z];
                    prop.orderInTrack = z;
                    prop.trackId = track.id;
                    proposalList.push(prop);
                }
            }
        }
    }

    addUnassignedProposalsToList(proposalList: Array<ProposalOrder>) {
        for (const unassignedProposal of this.unassignedProposals) {
            const prop = unassignedProposal;
            if (prop.id !== 0) {
                prop.unassigned = true;
                proposalList.push(prop);
            }
        }
    }

    isInvalidListOfProposals(proposalList: Array<ProposalOrder>): boolean {
        if (proposalList.length === 0) {
            return true;
        }
        return false;
    }

    loadcontent() {
        this.dataSubscription = this.storage.watch('selectedOpenId', {type: 'string'})
            .subscribe((openId) => {
                const openIdInt = parseInt(openId, 10);
                if (!isNaN(openIdInt) && openIdInt !== this.openSpaceId) {
                    this.openSpaceId = openIdInt;
                    this.loadAgenda();
                }
            });
    }

    sortUnassignedProposalsBy(orderBy: string) {
        this.switchSorting(orderBy);
        this.agendaService.getUnassignedProposals(this.openSpaceId, orderBy).subscribe(
            data => {
                if (data.UnasignedProposals.length > 0) {
                    this.unassignedProposals = data.UnasignedProposals;
                }
            });
    }

    switchSorting(orderBy: string) {
        this.filterByVotes = orderBy === 'maxVotes' ? true : false;
        this.filterByIntention = orderBy === 'intentionVotes' ? true : false;
    }

    publishAgenda(agenda: Agenda) {
        if (agenda.place) {
            this.updateAgenda(this.creteNewAgenda(agenda, true));
            this.toastr.success('Agenda publicada');
        } else {
            this.toastr.error('El campo LUGAR debe estar diligenciado');
        }
    }

    unPublishAgenda(agenda: Agenda) {
        this.updateAgenda(this.creteNewAgenda(agenda, false));
    }

    creteNewAgenda(agenda: Agenda, published: boolean) {
        const newAgenda = new Agenda();
        newAgenda.description = this.agenda.description;
        newAgenda.place = agenda.place;
        newAgenda.startTime = agenda.startTime;
        newAgenda.publicAgenda = published;
        newAgenda.openSpaceId = this.openSpaceId;
        newAgenda.id = agenda.id;
        newAgenda.sessions = agenda.sessions;
        return newAgenda;
    }

    genAgenda(agendaId: number) {
        const dialogRef = this.matDialogService.open(GenAgendaComponent, {
            data: {agendaId, editMode: false}
        });
        dialogRef.afterClosed().subscribe(
            (_ => {
                    this.loadAgenda();
                }
            ),
            (error) => {
                console.error(error);
                this.toastr.error(error);
            });
    }

}
